import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import formatValues, { formatReceived } from 'utils/formatValues';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';

export const baseURI = 'recaudacion/ejecutoras-pae/';

const biuldCompleteName = (ejecutor) => {
  const {
    nombre = '',
    apellido_paterno = '',
    apellido_materno = '',
  } = ejecutor;
  return `${nombre} ${apellido_paterno} ${apellido_materno}`.trim();
};

/**
 * GET Ejecutores
 * param {object} params
 * @returns {Promise<object>}
 */
export const getEjecutores = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Ejecutor
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getEjecutor = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Ejecutor
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEjecutor = async (values) => {
  try {
    const formatedValues = formatValues(values, {
      clean: false,
    });

    formatedValues.nombre_completo = biuldCompleteName(formatedValues);

    const response = await API.post(baseURI, formatedValues);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Ejecutor
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchEjecutor = async (id, values) => {
  try {
    const formatedValues = formatValues(values, {
      clean: false,
    });

    formatedValues.nombre_completo = biuldCompleteName(formatedValues);

    const response = await API.patch(`${baseURI}${id}`, formatedValues);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Ejecutor
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteEjecutor = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
